module.exports = __webpack_public_path__ + "img/logo-tds-gray.7d5e16bd.svg";